import React from 'react';
import TodoApp from './components/TodoApp';
import About from './components/About';

function App() {
  return (
    <div className="App">
      <About />
      <TodoApp />
    </div>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js